import { create } from 'zustand'

const useFramingPreviewImageStore = create((set, get) => ({
  previewImages: {},
  loadPreviewImage: (src) => {
    if (!src) return

    const existing = get().previewImages[src]
    if (existing?.status === 'loading' || existing?.status === 'ready') return

    set((state) => ({
      previewImages: {
        ...state.previewImages,
        [src]: { src, status: 'loading' },
      },
    }))

    const request = new Image()
    request.onload = () => {
      set((state) => ({
        previewImages: {
          ...state.previewImages,
          [src]: {
            src,
            status: request.naturalWidth > 0 && request.naturalHeight > 0 ? 'ready' : 'error',
            width: request.naturalWidth,
            height: request.naturalHeight,
          },
        },
      }))
      request.onload = null
      request.onerror = null
    }
    request.onerror = () => {
      set((state) => ({
        previewImages: {
          ...state.previewImages,
          [src]: { src, status: 'error' },
        },
      }))
      request.onload = null
      request.onerror = null
    }
    request.src = src
  },
}))

export default useFramingPreviewImageStore
